import { PostTaskSurveyAnswer } from '../store/taskManager/model'
import { NG_API_CLIENT } from 'services/api'
import { TaskSurveyAnswerStatus } from '../effectorStores/taskSurvey/model'

export const postTaskSurveyAnswer = async (data: PostTaskSurveyAnswer, currentAnswer: TaskSurveyAnswerStatus | null) =>
  NG_API_CLIENT.mutate('taskSurveyAnswer', {
    operations: [
      {
        operator: currentAnswer ? 'SET' : 'ADD',
        operand: currentAnswer ? { ...data, id: currentAnswer.id } : data,
      },
    ],
  })
